<template>
  <div class="collectionDetailGroup"
    :style="pageSetting">
    <div class="collectionNavCategory"
      :style="categoryStyle">
      <div class="categoryWrap"
        :style="listStyle">
        <div class="categoryList" :style="categoryHeight">
          {{ categoryLabel[lang] }} |
          {{ itemInfo.collectionItemName[lang] }}
        </div>
      </div>
    </div>
    <button type="button" class="btnClose" :style="{marginRight: `${pageFrame}px`}" @click.stop="close"></button>
    <div class="frame">
      <div
        class="collectionClass"
        :class="{ isUnknown: isUnknownClass }">
        <div
          v-for="classItem in collectionGroupItems"
          :key="classItem.collectionClassId"
          class="classItem">
          <div
            v-if="classItem.collectionClassId !== 'unknown'"
            :style="letterSpacing"
            class="className"
            @click.stop="setDetailGroupItemGallery({ classId: classItem.collectionClassId })">
            {{ classItem.collectionClassName[lang] }}
          </div>
          <div class="classSubItems">
            <div
              v-for="subItem in classItem.items"
              :key="subItem.subItemId"
              class="classSubItem"
              :class="{ isSelected: selectedSubItemByClass[classItem.collectionClassId] === subItem.subItemId }"
              @click.stop="setDetailGroupItemGallery({ subItemId: subItem.subItemId })">
              <div
                :style="{
                  backgroundImage: `url('${subItem.attribute.imageList[0]}')`
                }"
                class="thumb">
                <CollectionButton
                  v-if="isCollectableUser && useCollection"
                  :is-active="selectedSubItemByClass[classItem.collectionClassId] === subItem.subItemId"
                  @click="selectSubItem(classItem, subItem.subItemId)" />
              </div>
              <div class="subItemName">{{ subItem.collectionItemName[lang] }}</div>
            </div>
          </div>
        </div>
        <div v-if="selectedTotalPrice" class="totalPrice">
          <span :style="letterSpacing">PRICE</span>
          <span class="bar">|</span>
          <span>{{ priceFormat(selectedTotalPrice) }}</span>
        </div>
      </div>
    </div>
    <div class="myCollectionGroupBtns"
      :class="{isShowBtns: isShowBtns}"
      @mouseenter.stop.prevent="showBtns"
      @mouseleave.stop.prevent="hideBtns">
      <div class="myCollectionInput">
        <input
          v-model.trim="myCollectionName"
          type="text"
          class="input"
          placeholder="저장할 이름을 입력해주세요."
          @focus="focusedInput = true"
          @blur="focusedInput = false"
          @keydown.enter.prevent.stop="addMyCollection" />
        <button
          type="button"
          :disabled="!validateOnSubmit"
          class="addMyCollection"
          @click.stop="addMyCollection">
          SAVE
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import CollectionButton from './CollectionButton.vue'

export default {
  name: 'DetailGroup',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId',
    'isCollectableUser'
  ],
  components: {
    swiper,
    swiperSlide,
    CollectionButton
  },
  computed: {
    collectionItemId () {
      return this.$store.getters['collection/getDetailGroup']
    },
    getCategoryById () {
      return this.$store.getters['collection/getCategoryById'](this.categoryId)
    },
    categoryLabel () {
      const category = this.getCategoryById
      return category && category.categoryLabel
    },
    useCollection () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      return setting && setting.useCollection
    },
    isMyCollection () {
      return this.$route.name === 'myCollection'
    },
    getPointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    collectionSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    getCollectionNavSetting () {
      return this.$store.getters['collection/getCollectionNavSetting']
    },
    pageFrame () {
      return this.$store.getters['collection/getPageFrame']
    },
    pageSetting () {
      const setting = this.collectionSetting
      const itemDetail = this.itemInfo && this.itemInfo.attribute
      const navSetting = this.getCollectionNavSetting && this.getCollectionNavSetting.navTop
      const top = navSetting && navSetting.height
      const categoryHeight = this.getCollectionNavSetting && this.getCollectionNavSetting.category && this.getCollectionNavSetting.category.height
      const frame = this.pageFrame
      return  {
        top: `${Number(top) + Number(categoryHeight)}px`,
        padding: `0 ${frame}px 90px`,
        backgroundColor: setting.backgroundColor,
        color: itemDetail && itemDetail.detailColorActive ? itemDetail.detailTextColor : ''
      }
    },
    categoryHeight () {
      const setting = this.getCollectionNavSetting
      const category = setting && setting.category
      return {
        height: `${category && category.height}px`
      }
    },
    categoryStyle () {
      const setting = this.getCollectionNavSetting
      const category = setting && setting.category
      const fontFamily = (category && category.fontFamily && `${category.fontFamily.default}, ${category.fontFamily.default2}, ${category.fontFamily.default3}`) || ''
      const isMyCollection = this.isMyCollection
      const myCollectionSetting = this.getMyCollectionSetting
      return {
        ...this.letterSpacing,
        color: category && category.text && category.text.color,
        fontSize: `${category && category.text && category.text.size}px`,
        fontFamily: fontFamily,
        backgroundColor: isMyCollection ? (myCollectionSetting && myCollectionSetting.backgroundColor) : (category && category.backgroundColor)
      }
    },
    listStyle () {
      const setting = this.getCollectionNavSetting
      const category = setting && setting.category
      return {
        paddingTop: '0.5em',
        paddingBottom: '0.5em',
        borderColor: category && category.borderColor,
        borderBottom: 'none'
      }
    },
    letterSpacing () {
      const setting = this.getCollectionNavSetting
      const category = setting && setting.category
      function spacingToLts (spacing) {
        const numeric = parseFloat(spacing)
        if (isNaN(numeric)) return null
        return (numeric / 1000).toFixed(2)
      }
      return {
        letterSpacing: `${spacingToLts(category && category.text && category.text.spacing)}em`
      }
    },
    itemInfo () {
      const collectionItemId = this.collectionItemId
      return collectionItemId && this.$store.getters['collection/getItemByItemId'](collectionItemId)
    },
    collectionClassByCategoryId () {
      const categoryId = this.categoryId
      return this.$store.getters['collection/collectionClassByCategoryId'](categoryId)
    },
    collectionGroupItems () {
      const classes = this.collectionClassByCategoryId
      const typeSetting = this.itemInfo && this.itemInfo.typeSetting

      if (!typeSetting) {
        return []
      }

      if (!Array.isArray(classes) || classes.length === 0) {
        const items = typeSetting.unknown
        if (!Array.isArray(items) || items.length === 0) {
          return []
        }
        return [
          {
            collectionClassId: 'unknown',
            collectionClassName: {
              [this.lang]: ''
            },
            items
          }
        ]
      }

      return classes.reduce((result, item) => {
        const items = typeSetting[item.collectionClassId]

        if (!Array.isArray(items) || items.length === 0) {
          return result
        }
        result.push({
          ...item,
          items
        })
        return result
      }, [])
    },
    isUnknownClass () {
      return this.collectionGroupItems.length === 1 &&
        this.collectionGroupItems[0].collectionClassId === 'unknown'
    },
    selectedTotalPrice () {
      return this.collectionGroupItems.reduce((total, classItem) => {
        const selectedSubItemId = this.selectedSubItemByClass[classItem.collectionClassId]

        const selectedItem = classItem.items.find(subItem => {
          return subItem.subItemId === selectedSubItemId
        })

        return total + Number(selectedItem && selectedItem.price || 0)
      }, 0)
    },
    validateOnSubmit() {
      if (!this.myCollectionName.trim()) {
        return false
      }

      const hasRequired = this.collectionGroupItems
        .filter(classItem => classItem.isRequired)
        .every(classItem => {
          return !!this.selectedSubItemByClass[classItem.collectionClassId]
        })

      if (!hasRequired) {
        return false
      }

      return Object.values(this.selectedSubItemByClass).some(Boolean)
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.close()
    },
    itemInfo: {
      immediate: true,
      handler(item) {
        if (!item || this.myCollectionName) {
          return
        }
        this.myCollectionName = item.collectionItemName[this.lang]
      }
    },
    collectionGroupItems: {
      immediate: true,
      handler(items) {
        items.forEach(classItem => {
          const firstItem = classItem.items && classItem.items[0]

          if (
            classItem.isRequired &&
            firstItem &&
            !(classItem.collectionClassId in this.selectedSubItemByClass)
          ) {
            this.$set(
              this.selectedSubItemByClass,
              classItem.collectionClassId,
              firstItem.subItemId
            )
          }
        })
      }
    }
  },
  mounted () {
  },
  data() {
    return {
      selectedSubItemByClass: {},
      myCollectionName: '',
      isSubmitting: false,
      isShowBtns: false,
      focusedInput: false
    }
  },
  methods: {
    showBtns () {
      this.isShowBtns = true
    },
    hideBtns () {
      if (this.focusedInput) return
      this.isShowBtns = false
    },
    priceFormat (price) {
      return this.$store.getters['util/getPriceFormatter'](price)
    },
    selectSubItem(classItem, subItemId) {
      const classId = classItem.collectionClassId
      const current = this.selectedSubItemByClass[classId]

      if (classItem.isRequired && current === subItemId) {
        return
      }

      this.$set(
        this.selectedSubItemByClass,
        classId,
        current === subItemId ? null : subItemId
      )
    },
    getSubmitItems () {
      return this.collectionGroupItems
        .filter(classItem => {
          return !!this.selectedSubItemByClass[classItem.collectionClassId]
        })
        .map(classItem => {
          const collectionClassId = classItem.collectionClassId
          const subItemId = this.selectedSubItemByClass[collectionClassId]

          return {
            collectionClassId,
            subItemIds: [subItemId]
          }
        })
    },
    setDetailSubItem (subItem) {
      this.$store.commit('collection/setDetailSubItemGallery', {
        subItemId: subItem.subItemId,
        imageList: subItem.attribute.imageList
      })
    },
    // 그룹아이템 이미지 스와이프
    setDetailGroupItemGallery ({ subItemId, classId }) {
      // 세부아이템 클릭
      if (subItemId) {
        const imageList = []
        let startIndex = 0
        let found = false

        this.collectionGroupItems.forEach(classItem => {
          ;(classItem.items || []).forEach(item => {
            const images = (item.attribute && item.attribute.imageList) || []

            if (!found && item.subItemId === subItemId) {
              startIndex = imageList.length
              found = true
            }

            images.forEach(image => {
              imageList.push({
                image,
                subItemId: item.subItemId,
                collectionItemName: item.collectionItemName
              })
            })
          })
        })

        this.$store.commit('collection/setDetailGroupItemGallery', {
          type: 'item',
          imageList,
          startIndex
        })

        return
      }

      // 분류명 클릭
      if (classId) {
        return null // class gallery 안쓸예정
        const classList = this.collectionGroupItems
          .map(classItem => {
            const items = (classItem.items || [])
              .map(item => {
                const imageList = (item.attribute && item.attribute.imageList) || []

                return {
                  subItemId: item.subItemId,
                  collectionItemName: item.collectionItemName,
                  imageList
                }
              })
              .filter(item => item.imageList.length > 0)

            return {
              collectionClassId: classItem.collectionClassId,
              collectionClassName: classItem.collectionClassName,
              items
            }
          })
          .filter(classItem => classItem.items.length > 0)

        const startIndex = classList.findIndex(classItem => {
          return classItem.collectionClassId === classId
        })

        this.$store.commit('collection/setDetailGroupItemGallery', {
          type: 'class',
          classList,
          startIndex: startIndex >= 0 ? startIndex : 0
        })
      }
    },
    close () {
      this.$store.commit('collection/setDetailGroup', null)
    },
    async addMyCollection () {
      if (this.isSubmitting || !this.validateOnSubmit) {
        return
      }

      this.isSubmitting = true
      this.$store.commit('loading', true)

      const data = {
        pageId: this.pageId,
        collectionCategory: this.itemInfo.collectionCategoryId,
        collectionItemId: this.collectionItemId,
        categoryId: this.categoryId,
        myCollectionName: this.myCollectionName.trim(),
        subItems: this.getSubmitItems(),
        collectionClasses: this.collectionClassByCategoryId,
      }
      try {
        const res = await this.$store.dispatch(
          'collection/addCollection',
          data
        )

        if (!(res && res.result && res.result.orderUUID)) {
          throw new Error('내 콜렉션 저장에 실패했습니다.')
        }

        this.$store.commit(
          'collection/setToastMessage',
          '내 콜렉션에 추가되었습니다.'
        )

        await this.$store.dispatch(
          'collection/getMyCollectionItems',
          {
            pageId: this.pageId
          }
        )

        this.close()
        this.$store.commit('collection/setDetailGallery', null)
      } catch (error) {
        console.error(error)
        alert(error.message || '내 콜렉션 저장 중 오류가 발생했습니다.')
      } finally {
        this.isSubmitting = false
        this.$store.commit('loading', false)
      }
    }
  }
}
</script>